import React, { FC } from 'react';
import Flex from '@vromo/ui/components/Flex';
import Switch from '@vromo/ui/components/Switch';
import Tooltip from '@vromo/ui/components/Tooltip';
import {qaLabelTestSites} from './../../../../../../../common-qa-labels/sites'

const LOCALE_NO_POLICIES = 'To enable auto dispatch you must first create an Auto Dispatcher';

interface Props {
    autoDispatchEnabled: boolean;
    hasPolicies: boolean;
    onChange: () => void;
}

const AutodispatcherHeader: FC<Props> = ({ autoDispatchEnabled, hasPolicies, onChange }) => {
    const toggle = (
        <Switch
            testId={qaLabelTestSites.addSiteModal.autoDispatchToggle}
            checked={autoDispatchEnabled}
            disabled={!hasPolicies}
            onChange={onChange}
            style={{ marginBottom: 5, marginLeft: 20 }}
        />
    );

    return (
        <Flex horizontal="left" vertical="middle">
            <label>Auto Dispatcher</label>
            {!hasPolicies ? (
                <Tooltip label={LOCALE_NO_POLICIES}>
                    <div>{toggle}</div>
                </Tooltip>
            ) : (
                toggle
            )}
        </Flex>
    );
};

export default AutodispatcherHeader;
